module.exports = __webpack_public_path__ + "static/img/jingpingtuijian.b54b9846.png";